export const tickerHeadlines = [
  '某综艺收官录制花絮流出，嘉宾互动细节引发讨论',
  '网红「小雨酱」旧账号被翻出，早期言论引发热议',
  '流量男演员深夜聚餐路透照曝光，团队暂未回应',
  '选秀节目票数争议升级，节目组发布官方说明',
  '某品牌直播翻车片段被剪辑传播，客服称已核实',
  '网友投稿：剧组探班偶遇现场，氛围细节首次公开',
  '音乐节后台偷拍素材流出，主办方回应正在核查',
];